<template>
    <!-- 面包屑导航 对element-ui的面包屑进行二次封装 -->
    <div class="levelbar" style="border-bottom: 1px solid #dfe0e0;background-color:#dfe0e0 ">
        <span class="text"> 当前位置：</span>
        <el-breadcrumb class="app-levelbar" separator="/">
            <el-breadcrumb-item v-for="(item,index)  in levelList" :key="index">
                <router-link v-if='index==levelList.length-1' to="">{{item.name}}</router-link>
                <router-link v-else :to="item.path">{{item.name}}</router-link>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

</template>

<script>
  export default {
    created() {
      this.getBreadcrumb();
    },
    data() {
      return {
        levelList: null
      };
    },
    methods: {
      getBreadcrumb() {
        let matched = this.$route.matched.filter(item => item.name); //filter 过滤器
        this.levelList = matched;
      }

    },
    watch: {
      $route() {
        this.getBreadcrumb();
      }
    }
  };
</script>

<style rel="stylesheet/scss" scoped>
    .levelbar .text {
        display: inline-block;
        margin-top: -5px;
        font-size: 16px;
    }

    .levelbar .app-levelbar {
        display: inline-block;
    }

    .levelbar .app-levelbar .el-breadcrumb__item__inner a {
        text-decoration: none;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// Levelbar.vue?ee6b463e